import React, { memo } from 'react';

import { cn } from '@/lib/utils/cn';

interface I_HandleBarProps {
  variant?: 'default' | 'top';
}

export const HandleBar = memo(({ variant = 'default' }: I_HandleBarProps) => (
  <div
    className={cn(
      'group-data-[vaul-drawer-direction=right]/drawer-content:hidden mx-auto mt-3 h-1 w-16 rounded-full bg-white/30 group-data-[vaul-drawer-direction=bottom]/drawer-content:block',
      variant === 'top' ? 'absolute left-1/2 -translate-x-1/2 -top-5 mt-0' : ''
    )}
  />
));

HandleBar.displayName = 'HandleBar';
